import React from "react";
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

import Image from "next/image";
import Link from "next/link";
import AOS from "aos";

import Pro16 from "@/public/static/images/project_16.jpg";
import Pro17 from "@/public/static/images/project_17.jpg";
import Pro18 from "@/public/static/images/project_18.jpg";
import Pro19 from "@/public/static/images/project_19.jpg";
import Pro20 from "@/public/static/images/project_20.jpg";

import Pro21 from "@/public/static/images/project_21.jpg";

function premium_goods_production() {
  AOS.init({
    offset: 200,
    duration: 600,
    easing: "ease-in-out-sine",
    delay: 200,
    mirror: true,
  });
  return (
    <div className="wrapper">
      <Header />
      <section className="proj">
        <div className="container">
          <div className="row">
            <div className="col-12 project_box">
              <div className="row">
                <div className="col-12 col-md-7 order-md-1 order-2">
                  <div>
                    <div className="project-heading">
                      <h1 className="t-green">Premium Goods Production</h1>
                    </div>
                  </div>
                  {/* <div className="badge_box">
                    <Link href="/ourservice/sales_promotion_tools">
                      <span className="badge rounded-pill text-bg-light">
                        Media Printing
                      </span>
                    </Link>
                    <Link href="/ourservice/printing_logistics">
                      <span className="badge rounded-pill text-bg-light">
                        Material Printing
                      </span>
                    </Link>
                  </div> */}
                  <div className="project_content-inner project-list">
                    <p>
                      With our profound expertise in the printing industry and{" "}
                      <br />
                      advancements in printing technology, we have <br />
                      broadened our service offerings to include the <br />
                      production of premium goods.
                    </p>
                  </div>
                </div>
                <div className="col-12 col-md-5 order-md-2 order-1">
                  <Image
                    loading="lazy"
                    src={Pro16}
                    alt="Premium Goods Production"
                    className="img-fluid mx-auto "
                  />
                </div>
              </div>
            </div>

            <div className="col-12 project_content">
              <div className="row mb-5">
                <div className="col-12 mb-5 project_content-inner">
                  <h2 className="t-green mb-2">Premium Goods Production</h2>
                  <p className="mb-1">Procurement from around the world</p>
                  <p className="mb-1">
                    For Clients, Dealers, Employees, VIP guest + For PR and POP
                  </p>
                  <p className="mb-1">
                    Taking today’s market into consideration,ITP creative team
                    is able to create and develop marketing and sales promotion
                    materials. With 20 years of experiences, we are your
                    professional partner to turn your ideas into Link reality.
                  </p>
                </div>

                <div className="col-12 mb-3 project_content-inner">
                  <div className="d-none d-sm-block">
                    <Image
                      loading="lazy"
                      src={Pro21}
                      alt="Premium Goods Production"
                      className="img-fluid mb-3"
                    />
                  </div>
                  <div className="d-block d-sm-none">
                    <Image
                      loading="lazy"
                      src={Pro17}
                      alt="Premium Goods Production"
                      className="img-fluid mb-3"
                    />
                    <Image
                      loading="lazy"
                      src={Pro18}
                      alt="Premium Goods Production"
                      className="img-fluid mb-3"
                    />
                    <Image
                      loading="lazy"
                      src={Pro19}
                      alt="Premium Goods Production"
                      className="img-fluid mb-3"
                    />
                    <Image
                      loading="lazy"
                      src={Pro20}
                      alt="Premium Goods Production"
                      className="img-fluid mb-3"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default premium_goods_production;
